import Vue2 from 'vue/dist/vue.common.js'
import Vuex from 'vuex'

import auth from 'Auth/Resources/assets/js/store'
import base from 'Base/Resources/assets/js/store'
import user from 'User/Resources/assets/js/store'
import union from 'Union/Resources/assets/js/store'
import discussion from 'Discussion/Resources/assets/js/store'
import document from 'Document/Resources/assets/js/store'
import membership from 'Membership/Resources/assets/js/store'
import activityFeed from 'ActivityFeed/Resources/assets/js/store'
import notification from 'Notification/Resources/assets/js/store'
import communication from 'Communication/Resources/assets/js/store'
import resource from 'Resource/Resources/assets/js/store'
import calendar from 'Calendar/Resources/assets/js/store/index'
import modal from 'Base/Resources/assets/js/store/modals'
import form from 'FormBuilder/Resources/assets/js/store'
import payments from 'Payments/Resources/assets/js/store'
import exports from 'Export/Resources/assets/js/store'
import managedPage from 'ManagedPage/Resources/assets/js/store'

import * as actions from './actions'
import * as getters from './getters'

Vue2.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    auth,
    base,
    user,
    union,
    discussion,
    document,
    membership,
    activityFeed,
    notification,
    communication,
    resource,
    calendar,
    modal,
    form,
    payments,
    exports,
    managedPage,
  },
  strict: debug,
})